<template>
  <div class="picker-field" :class="{'picker-field__focus': isFocus}">

    <div class="weui-cell weui-cell_access" v-if="isNeedInput">
      <div class="weui-cell__hd" v-if="label">
        <label for class="weui-label">{{label}}</label>
      </div>
      <div class="weui-cell__bd" >
        <input class="weui-input" type="text" :value="value" ref="input" @input="onchange" placeholder="请输入..."/>
      </div>
      <div class="weui-cell__ft" @click="open">
        <span v-show="!display&&!value">请选择</span>
      </div>
    </div>

    <div class="weui-cell weui-cell_access" v-else @click="open">
      <div class="weui-cell__hd" v-if="label">
        <label for class="weui-label">{{label}}</label>
      </div>
      <div class="weui-cell__bd">
        <span v-if="display">{{display}}</span>
        <span v-else>{{value}}</span>
      </div>
      <div class="weui-cell__ft">
        <span v-show="!display&&!value">请选择</span>
      </div>
    </div>

    <div v-if="showDialog">
      <div class="weui-mask weui-animate-fade-in" @click="close"></div>
      <div class="weui-half-screen-dialog weui-picker weui-animate-slide-up">
        <div class="weui-half-screen-dialog__hd">
          <div class="weui-half-screen-dialog__hd__side">
            <button class="weui-icon-btn weui-icon-btn_close weui-picker__btn" @click="close">关闭</button>
          </div>
          <div class="weui-half-screen-dialog__hd__main">
            <strong class="weui-half-screen-dialog__title">{{computedTitle}}</strong>
          </div>
        </div>
        <div class="weui-half-screen-dialog__tbar">
          <slot name="tbar"></slot>
        </div>
        <div class="weui-half-screen-dialog__bd">
          <slot></slot>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    label: String,
    isNeedInput: {
      type: Boolean,
      default: false
    },
    display: String,
    value: String,
    title: String,
    isFocus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  computed: {
    computedTitle() {
      var me = this;
      return me.title || "选择" + me.label;
    }
  },
  methods: {
    open() {
      var me = this;
      me.showDialog = true;
      me.$nextTick(function() {
        me.$emit("open");
      });
    },
    close() {
      this.showDialog = false;
    },
    onchange() {
      var me = this
      me.$emit("onchange", me.$refs.input.value)
    }
  }
};
</script>

<style>
.weui-cells > .picker-field:not(:first-child) {
  position: relative;
}
.weui-cells > .picker-field:not(:first-child):before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid var(--weui-FG-3);
  /* color: rgba(0, 0, 0, 0.1); */
  color: var(--weui-FG-3);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  left: 16px;
  z-index: 2;
}
.picker-field .weui-picker {
  display: -webkit-box;
  display: -ms-flexbox;
  flex-direction: column
}
.picker-field .weui-picker .weui-half-screen-dialog__hd {
  height: 6em;
}
.picker-field .weui-picker .weui-half-screen-dialog__bd {
  flex: 1;
}
.picker-field__focus .weui-half-screen-dialog {
  max-height: 75%;
}
</style>